import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const QRCodeTool: React.FC<{ slug?: string }> = () => {
  const [input, setInput] = useState('https://focuzon.com');
  const [qrDataUrl, setQrDataUrl] = useState<string>('');

  useEffect(() => {
    if (input.trim()) {
      QRCode.toDataURL(input, { width: 256, margin: 2 })
        .then(setQrDataUrl)
        .catch(() => setQrDataUrl(''));
    } else {
      setQrDataUrl('');
    }
  }, [input]);

  const download = () => {
    if (!qrDataUrl) return;
    const a = document.createElement('a');
    a.href = qrDataUrl;
    a.download = 'qrcode.png';
    a.click();
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Enter URL or text</label>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="https://example.com or any text"
          className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400"
        />
      </div>
      {qrDataUrl && (
        <div className="flex flex-col items-center gap-4 p-6 bg-orange-50 rounded-xl border border-orange-100">
          <img src={qrDataUrl} alt="QR Code" className="rounded-xl border border-orange-100 p-3 bg-white shadow-sm" loading="lazy" />
          <button
            onClick={download}
            className="px-6 py-3 bg-orange-500 text-white rounded-xl font-medium hover:bg-orange-600 shadow-sm hover:shadow transition-all"
          >
            Download PNG
          </button>
        </div>
      )}
    </div>
  );
};

export default QRCodeTool;
